/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardFulfillmentClaimBody
 */
export interface RewardFulfillmentClaimBody {
    /**
     * ObjectId of the PrizePool slot the user won (matches an entry in their ChallengeMembership.prizesWon[]). Exactly one of prizePoolId or distributedRewardId must be provided.
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    prizePoolId?: string;
    /**
     * ObjectId of the DistributedReward (wheel-spin / gamification / manual grant path). Exactly one of prizePoolId or distributedRewardId must be provided.
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    distributedRewardId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    fullName: string;
    /**
     * Optional override; defaults to the authenticated user's account email when omitted. RTTR's compact modal omits this field entirely.
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    email?: string;
    /**
     * Required contact phone. Free-text. Max 30 characters.
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    addressLine1: string;
    /**
     * 
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    city: string;
    /**
     * US state code (2 letters, e.g. "CA").
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    state: string;
    /**
     * US ZIP code (5 digits or 5+4 ZIP+4).
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    zipCode: string;
    /**
     * Defaults to RESIDENTIAL when omitted.
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    addressType?: RewardFulfillmentClaimBodyAddressTypeEnum;
    /**
     * Optional delivery instructions (gate code, leave-with-neighbor, etc.). Max 1000 characters.
     * @type {string}
     * @memberof RewardFulfillmentClaimBody
     */
    notes?: string;
}


/**
 * @export
 */
export const RewardFulfillmentClaimBodyAddressTypeEnum = {
    RESIDENTIAL: 'RESIDENTIAL',
    BUSINESS: 'BUSINESS'
} as const;
export type RewardFulfillmentClaimBodyAddressTypeEnum = typeof RewardFulfillmentClaimBodyAddressTypeEnum[keyof typeof RewardFulfillmentClaimBodyAddressTypeEnum];


/**
 * Check if a given object implements the RewardFulfillmentClaimBody interface.
 */
export function instanceOfRewardFulfillmentClaimBody(value: object): value is RewardFulfillmentClaimBody {
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    return true;
}

export function RewardFulfillmentClaimBodyFromJSON(json: any): RewardFulfillmentClaimBody {
    return RewardFulfillmentClaimBodyFromJSONTyped(json, false);
}

export function RewardFulfillmentClaimBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardFulfillmentClaimBody {
    if (json == null) {
        return json;
    }
    return {
        
        'prizePoolId': json['prizePoolId'] == null ? undefined : json['prizePoolId'],
        'distributedRewardId': json['distributedRewardId'] == null ? undefined : json['distributedRewardId'],
        'fullName': json['fullName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'city': json['city'],
        'state': json['state'],
        'zipCode': json['zipCode'],
        'addressType': json['addressType'] == null ? undefined : json['addressType'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function RewardFulfillmentClaimBodyToJSON(json: any): RewardFulfillmentClaimBody {
    return RewardFulfillmentClaimBodyToJSONTyped(json, false);
}

export function RewardFulfillmentClaimBodyToJSONTyped(value?: RewardFulfillmentClaimBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prizePoolId': value['prizePoolId'],
        'distributedRewardId': value['distributedRewardId'],
        'fullName': value['fullName'],
        'email': value['email'],
        'phone': value['phone'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'city': value['city'],
        'state': value['state'],
        'zipCode': value['zipCode'],
        'addressType': value['addressType'],
        'notes': value['notes'],
    };
}

